module.exports = __webpack_public_path__ + "img/guide-suunto-1-ios.844cf139.jpg";